import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { routingConstants } from "../Constants/routingConstants";

const RestrictedRoute = ({ accessKey, children }) => {
  const { clientUserAllPermissions } = useSelector((state) => state.session);
  if (clientUserAllPermissions && clientUserAllPermissions[accessKey] == 0) {
    return (
      <Navigate
        to={routingConstants.dashboard}
        state={{
          message: "Restricted Access, Please contact your administrator",
        }}
      />
    );
  }
  return <div>{children}</div>;
};

export default RestrictedRoute;
